import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import OtherPage from "./pages/OtherPage";
import Whoops from "./pages/Whoops";
import Home from "./pages/Home";
import Quiz from "./pages/Quiz";
import Result from "./pages/Result";
import QuizFinal from "./pages/QuizFinal";

export default function AllRoutes(){
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/other" element={<OtherPage />} />
            <Route path="/Result" element={<Result />} />
            <Route path="/QuizFinal" element={<QuizFinal />} />
            <Route path="*" element={<Whoops />} />
        </Routes>
    )
}